import React from 'react';

export default function PageHero({ badge, title, subtitle }) {
  return (
    <div style={{ marginBottom: 32, width: '100%', minWidth: 0 }}>
      <span style={{
        display: 'inline-block',
        border: '1px solid #F97316',
        color: '#F97316',
        background: 'rgba(249,115,22,0.08)',
        padding: '4px 12px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.08em',
        fontFamily: 'Inter, sans-serif',
      }}>{badge}</span>
      <h1 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(32px, 8vw, 52px)',
        color: '#F1F5F9',
        lineHeight: 1.1,
        marginTop: 8,
        marginBottom: 8,
        maxWidth: '100%',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
      }}>{title}</h1>
      {subtitle && (
        <p style={{
          color: '#9CA3AF',
          fontSize: 'clamp(14px, 3.8vw, 16px)',
          maxWidth: 520,
          lineHeight: 1.6,
          margin: 0,
          fontFamily: 'Inter, sans-serif',
          maxInlineSize: '100%',
          overflowWrap: 'anywhere',
        }}>{subtitle}</p>
      )}
    </div>
  );
}
